export const Protocols = {
  UploadServiceAgreement: 0
}

const protocols = {
  [Protocols.UploadServiceAgreement]: {
    name: '《内容上传服务协议》',
    key: Protocols.UploadServiceAgreement,
    title: '魔欢智慧美育云平台内容上传服务协议',
    url:
      'https://public.ecoach.evideo.tech/protocols-files/uploadServiceAgreement.protocol'
  }
}

export default protocols
